import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "q-mb-sm" }
const _hoisted_4 = { class: "q-mb-sm" }
const _hoisted_5 = { class: "q-mb-sm" }
const _hoisted_6 = { class: "q-mb-sm" }
const _hoisted_7 = { class: "q-mb-sm" }
const _hoisted_8 = { class: "q-mb-sm" }
const _hoisted_9 = { class: "q-mb-sm" }
const _hoisted_10 = { class: "q-mb-sm" }
const _hoisted_11 = { class: "row q-gutter-sm q-pt-md" }

import { EnumButtonSizes } from "@/enums/enums"
import { usePCStore } from "@/stores/pcStore"
import { usePagesUtilStore } from "@/stores/pagesUtilStore"
import { ref, computed, watch, onMounted } from "vue"
import ModalPCsInstitutional from "./ModalPCsInstitutional.vue"
import { useRedeSubredeStore } from "@/stores/redeSubredeStore"


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalFilterPcsInstitutional',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const pcStore = usePCStore()
const pagesUtilStore = usePagesUtilStore()
const redeSubredeStore = useRedeSubredeStore()


const emit = __emit

onMounted(async () => {
  await pcStore.fetchPCs(0, 100000)
})

/* =======================
 * OPTIONS DINÂMICOS
 * ======================= */
//const cidadeOptions = computed(() => [...new Set(pcStore.pcs.map(p => p.nomcidredeautoatndto))].filter(Boolean));
//const ufOptions = computed(() => [...new Set(pcStore.pcs.map(p => p.ufredeautoatndto))].filter(Boolean));

const pcsParaFiltro = computed(() => {
  const subredesSelecionadas =
    redeSubredeStore.subredesSelecionadas

  if (!subredesSelecionadas?.length) {
    return pcStore.pcs
  }

  return pcStore.pcs.filter(pc =>
    subredesSelecionadas.some(
      s => s.nomSubredeAutoAtndto === pc.nomsubredeautoatndto
    )
  )
})

const cidadeOptions = computed(() =>
  [...new Set(
    pcsParaFiltro.value
      .map(p => p.nomcidredeautoatndto)
      .filter((v): v is string => !!v)
  )]
    .sort((a, b) => a.localeCompare(b, 'pt-BR'))
)

const ufOptions = computed(() =>
  [...new Set(
    pcsParaFiltro.value
      .map(p => p.ufredeautoatndto)
      .filter((v): v is string => !!v)
  )]
    .sort((a, b) => a.localeCompare(b, 'pt-BR'))
)

const segmentoOptions = computed(() =>
  [...new Set(
    pcsParaFiltro.value
      .map(p => p.nomsegmmerclocalptoatndto)
      .filter((v): v is string => !!v)
  )]
    .sort((a, b) => a.localeCompare(b, 'pt-BR'))
)

const tipoMaquinaOptions = computed(() =>
  [...new Set(
    pcsParaFiltro.value
      .map(p => p.nomtpmaqautoatndto)
      .filter((v): v is string => !!v)
  )]
    .sort((a, b) => a.localeCompare(b, 'pt-BR'))
)


// ✅ CORRETO - options com label e value
const subredeOptions = computed(() => {
  if (redeSubredeStore.subredesSelecionadas.length > 0) {
    return redeSubredeStore.subredesSelecionadas.map(s => ({
      label: s.nomSubredeAutoAtndto,
      value: s.codSubredeAutoAtndto // ✅ já é number, sem conversão
    }));
  }

  return [...new Set(pcStore.pcs.map(p => p.nomsubredeautoatndto))]
    .filter(Boolean)
    .map(nome => {
      const pc = pcStore.pcs.find(p => p.nomsubredeautoatndto === nome);
      return {
        label: nome,
        value: pc?.codsubredeautoatndto // ✅ já é number
      };
    });
});

//const segmentoOptions = computed(() => [...new Set(pcStore.pcs.map(p => p.nomsegmmerclocalptoatndto))].filter(Boolean));
//const tipoMaquinaOptions = computed(() => [...new Set(pcStore.pcs.map(p => p.nomtpmaqautoatndto))].filter(Boolean));

const redeLabel = computed(() => "Banco24Horas");


/* =======================
 * BOTÕES
 * ======================= */
const onFetchBtnClick = async () => {
  await pcStore.fetchPCs(0, 10)

  pagesUtilStore.showModalFilterPCs = false
  pagesUtilStore.showModalPCsInstitutional = true
}

/* ✅ AQUI ESTÁ O PONTO MAIS IMPORTANTE */

const onContinueBtnClick = () => {
  emit('update:modelValue', false)
};

/* =======================
 * CSV
 * ======================= */
const triggerFileUpload = () => {
  document.getElementById("file-upload")?.click();
};

const onFileChangeAndUpload = async (event: Event) => {
  const input = event.target as HTMLInputElement;

  if (input.files && input.files[0]) {
    const file = input.files[0];
    const reader = new FileReader();

    reader.onload = async (e) => {
      const csv = e.target?.result as string;
      const ids = csv.split("\n").slice(1).map(r => r.split(",")[0].trim());

      pcStore.pcFilter.filterPc.codpontocaptura = ids;
      await pcStore.fetchPCs(0, 10, ids);
    };

    reader.readAsText(file);
  }
};

const emitClose = (val: boolean) => {
  emit('update:modelValue', val);
};

watch(
  () => redeSubredeStore.subredesSelecionadas,
  (subredes) => {
    if (subredes.length > 0) {
      pcStore.pcFilter.filterPc.codsubredeautoatndto =
        subredes.map(s => s.codSubredeAutoAtndto)
    }
  },
  { immediate: true }
)


return (_ctx: any,_cache: any) => {
  const _component_c_modal_title = _resolveComponent("c-modal-title")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_c_q_btn = _resolveComponent("c-q-btn")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_dialog, {
      "model-value": __props.modelValue,
      persistent: "",
      "onUpdate:modelValue": emitClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"420px","max-width":"90vw","padding":"16px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_c_modal_title, {
              propModalTitle: "Filtro de PCs",
              propModalDescription: "Pesquise e filtre por PCs"
            }),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-caption q-mb-xs" }, "Código do PC", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: _unref(pcStore).pcFilter.filterPc.codpontocaptura,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(pcStore).pcFilter.filterPc.codpontocaptura) = $event)),
                    outlined: "",
                    dense: "",
                    class: "full-width"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-caption q-mb-xs" }, "Nome do PC", -1)),
                  _createVNode(_component_q_input, {
                    modelValue: _unref(pcStore).pcFilter.filterPc.nompontocaptura,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(pcStore).pcFilter.filterPc.nompontocaptura) = $event)),
                    outlined: "",
                    dense: "",
                    class: "full-width"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-caption q-mb-xs" }, "Cidade", -1)),
                  _createVNode(_component_q_select, {
                    modelValue: _unref(pcStore).pcFilter.filterPc.nomcidredeautoatndto,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(pcStore).pcFilter.filterPc.nomcidredeautoatndto) = $event)),
                    options: cidadeOptions.value,
                    outlined: "",
                    dense: "",
                    clearable: "",
                    class: "full-width"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-caption q-mb-xs" }, "UF", -1)),
                  _createVNode(_component_q_select, {
                    modelValue: _unref(pcStore).pcFilter.filterPc.ufredeautoatndto,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(pcStore).pcFilter.filterPc.ufredeautoatndto) = $event)),
                    options: ufOptions.value,
                    outlined: "",
                    dense: "",
                    clearable: "",
                    class: "full-width"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-caption q-mb-xs" }, "Rede", -1)),
                  _createVNode(_component_q_input, {
                    "model-value": redeLabel.value,
                    outlined: "",
                    dense: "",
                    readonly: "",
                    class: "full-width"
                  }, null, 8, ["model-value"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-caption q-mb-xs" }, "Subrede", -1)),
                  _createVNode(_component_q_select, {
                    modelValue: _unref(pcStore).pcFilter.filterPc.codsubredeautoatndto,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(pcStore).pcFilter.filterPc.codsubredeautoatndto) = $event)),
                    options: subredeOptions.value,
                    "option-value": "value",
                    "option-label": "label",
                    "emit-value": "",
                    "map-options": "",
                    multiple: "",
                    readonly: "",
                    outlined: "",
                    dense: "",
                    clearable: "",
                    class: "full-width"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-caption q-mb-xs" }, "Segmento", -1)),
                  _createVNode(_component_q_select, {
                    modelValue: _unref(pcStore).pcFilter.filterPc.nomsegmmerclocalptoatndto,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(pcStore).pcFilter.filterPc.nomsegmmerclocalptoatndto) = $event)),
                    options: segmentoOptions.value,
                    outlined: "",
                    dense: "",
                    clearable: "",
                    class: "full-width"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-caption q-mb-xs" }, "Tipo Máquina", -1)),
                  _createVNode(_component_q_select, {
                    modelValue: _unref(pcStore).pcFilter.filterPc.nomtpmaqautoatndto,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(pcStore).pcFilter.filterPc.nomtpmaqautoatndto) = $event)),
                    options: tipoMaquinaOptions.value,
                    outlined: "",
                    dense: "",
                    clearable: "",
                    class: "full-width"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_c_q_btn, {
                    propBtnLabel: "Importar PCs",
                    propBtnSize: _unref(EnumButtonSizes).LARGE_1,
                    onClick: triggerFileUpload
                  }, null, 8, ["propBtnSize"]),
                  _createVNode(_component_c_q_btn, {
                    propBtnLabel: "Buscar",
                    propBtnSize: _unref(EnumButtonSizes).LARGE_1,
                    onClick: onFetchBtnClick
                  }, null, 8, ["propBtnSize"]),
                  _createVNode(_component_c_q_btn, {
                    propBtnLabel: "Continuar",
                    propBtnSize: _unref(EnumButtonSizes).LARGE_1,
                    onClick: onContinueBtnClick
                  }, null, 8, ["propBtnSize"])
                ])
              ])
            ]),
            _createElementVNode("input", {
              type: "file",
              accept: ".csv",
              id: "file-upload",
              style: {"display":"none"},
              onChange: onFileChangeAndUpload
            }, null, 32)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(ModalPCsInstitutional)
  ], 64))
}
}

})